
import React, { useState } from 'react';

import { ReactComponent as SearchIcon } from '../../assets/icons/search-icon.svg';

// Filtro: testo + date-range
const ReferentiFilterBar = ({ filterParams, onChange }) => {
    const { searchterm } = filterParams;
    return (
        <div className="vista-filter-bar">
            <div className="search-wrapper">
                <SearchIcon className="search-icon" />
                <input
                    type="text"
                    className="search"
                    name="searchterm"
                    placeholder="Ricerca per cognome, nome o email"
                    value={searchterm}
                    onChange={e => onChange({ ...filterParams, searchterm: e.target.value })}
                />
            </div>
        </div>
    );
}
export default ReferentiFilterBar;